const NOTES = [{
  id: '1',
  description: 'Happy birthday Edgar!',
  date: '23/10/2016'
}, {
  id: '2',
  description: 'Merry Christmas!',
  date: '25/12/2016'
}, {
  id: '3',
  description: 'Birthday Graciela!',
  date: '15/1/2017'
}, {
  id: '4',
  description: 'Birthday Jordi!',
  date: '31/7/2016'
}]

export default NOTES



/** WEBPACK FOOTER **
 ** ./src/data/notes.js
 **/